
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"91.588","height":"68.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M84.042 0h-5.284L7.546.246A7.555 7.555 0 000 7.792v53.162A7.555 7.555 0 007.546 68.5l76.5-.246a7.555 7.555 0 007.546-7.546V7.546A7.555 7.555 0 0084.042 0zM3.019 7.792a4.533 4.533 0 014.528-4.528l71.211-.246h5.284a4.533 4.533 0 014.528 4.528v6.942l-85.551.246zM88.57 60.708a4.533 4.533 0 01-4.528 4.528l-76.5.246a4.533 4.533 0 01-4.528-4.528v-43.2l85.551-.246v43.2z","fill":"#eceef2"}}),_c('g',{attrs:{"fill":"#f9487f"}},[_c('path',{attrs:{"d":"M38.305 32.929a1.077 1.077 0 00-1.522 0l-6.467 6.467a1.076 1.076 0 000 1.522l6.382 6.382a1.076 1.076 0 001.522-1.522l-5.621-5.62 5.707-5.707a1.076 1.076 0 00-.001-1.522zM54.214 32.929a1.076 1.076 0 00-1.522 1.522l5.706 5.706-5.621 5.621a1.076 1.076 0 001.522 1.522l6.382-6.382a1.078 1.078 0 000-1.522zM49.707 29.035a1.075 1.075 0 00-1.388.624l-7.648 20.146a1.076 1.076 0 102.013.763l7.647-20.146a1.076 1.076 0 00-.624-1.387z"}})])])
          )
        }
      }
    